import axios from 'axios';
import config from '../../../../../../core/config/configureSettings';
import { constructServiceURL } from '../../../../../../core/modules/common/tools/URLTools';

const apiFetchCarrierM39ComplianceLocation = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getCarrierM39ComplianceLocation',
    stub: config.useStubbedEndpoints,
  });

  return axios.post(serviceURL, payload, {
    cancelToken: payload.token,
  });
};

export default apiFetchCarrierM39ComplianceLocation;
